// extracted by mini-css-extract-plugin
export default {"linkWidget":"Styles_linkWidget__xhWiu","selected":"Styles_selected__Fuqmz"};